import React from "react";
import { Button } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import "./nujobsEvaluationReadyPage.scss";

function NuJobsEvaluationsReadyPage() {
  const { ev_id } = useParams();
  const navigate = useNavigate();

  const startExam = () => {
    navigate(`/nujobshome/nujobs/qsetcandidateexamcardlist/${ev_id}`);
  };

  return (
    <div className="nujobs-evaluation-consent">
      <div>
        <h2>Ready to Start Your Exam?</h2>
        <p>This exam requires your camera and will enter fullscreen mode.</p>
        <Button type="primary" onClick={startExam}>
          Click to Start
        </Button>
      </div>
    </div>
  );
}

export default NuJobsEvaluationsReadyPage;
